import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'terms' || hash === 'privacy') {
        setCurrentPage(hash);
      } else {
        setCurrentPage('home');
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (currentPage === 'terms') {
    return <TermsOfService data-id="element-0" />;
  }
  if (currentPage === 'privacy') {
    return <PrivacyPolicy data-id="element-1" />;
  }
  return <LandingPage data-id="element-2" />;
}